import React from "react";

export default function CheckBox({ item, name, onClick }) {
  return (
    <label className="py-0.5 flex items-center w-max">
      <input type="checkbox" checked={item.DONE} onChange={onClick} />
      <span className="span-check"></span>
      <span className="pl-2 text-xs">{name}</span>
    </label>
  );
}
